import { render } from "./Item.vue?vue&type=template&id=a13a8156"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
script.render = render

export default script